import { withTranslation } from '../Translator';
import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import PureSearchableMultiselectListbox from './SearchableMultiselectListbox';

export const SearchableMultiselectListbox = AsControl()(withTranslation('components')(PureSearchableMultiselectListbox));
export const SearchableMultiselectListboxControl = bindControlToForm()(SearchableMultiselectListbox);
export const AutoSavedSearchableMultiselectListboxControl = autoSaved({ saveOnChange: true })(SearchableMultiselectListboxControl);
